import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { formatMoney, getAmountCollectedToday, getAmountToCollectToday, isLoanCompleted, isLoanDueToday, isLoanExpired, isLoanOutstanding } from "../Helpers";
import { getInlineLoader } from "../Helpers";
import { MdSubject } from "react-icons/md";
import logo from '../assets/logo.png';

export default function View() {
  const appContext = useContext(AppContext);

  const [ready, setReady] = useState(false);

  

  async function init() {
    setReady(false);
    await Promise.all([
      appContext.getDashboardCounts(),
    ])
    setReady(true);
  }

  
  useEffect(() => {
    init();
  }, []);

  

  

  if (ready && appContext.currentSchoolData && appContext.currentUserData) {
    return (
      <div
        className="container"
      >
        <div className="row">
          <div className="col-md-12">
            <h6 
              className="font-light"
              style={{
                fontSize: "32px"
              }}
            >
              Welcome Back, {appContext.currentUserData.firstName}
            </h6>
          </div>

          <div className="col-md-12 mt-4 mb-4">
            <div className="row">
              
              <div className="col-md-4">
                <img
                  src={logo}
                  style={{
                    width: "100%",
                  }}
                />
              </div>
              <div className="col-md-8">
                <h6
                  className="font-bold"
                  style={{
                    fontSize: "32px",
                    textTransform: "uppercase",
                  }}
                >
                  {appContext.currentSchoolData.name}
                </h6>
                <h6
                  className="text-muted"
                  style={{
                    fontSize: "12px"
                  }}
                >
                  Email: {appContext.currentSchoolData.contactEmail}
                </h6>
                <h6
                  className="text-muted"
                  style={{
                    fontSize: "12px"
                  }}
                >
                  Phone: {appContext.currentSchoolData.contactPhone}
                </h6>
                <h6
                  className="text-muted"
                  style={{
                    fontSize: "12px"
                  }}
                >
                  Website: {appContext.currentSchoolData.contactWebsite}
                </h6>
                <h6
                  className="text-muted"
                  style={{
                    fontSize: "12px"
                  }}
                >
                  Address: {appContext.currentSchoolData.contactAddress}
                </h6>
              </div>
              
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div
              className="card"
              style={{
                cursor: "pointer"
              }}
              onClick={() => {
                appContext.navTo({
                  item: 'classrooms',
                })
              }}
            >
              <div className="card-body">
                <h6
                  className="card-title"
                >
                  Classrooms
                </h6>

                <h6
                  className="text-end"
                  style={{
                    fontSize: "42px"
                  }}
                >
                  {formatMoney(appContext.dashboardCounts?.classrooms || 0)}
                </h6>								
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div
              className="card"
              style={{
                cursor: "pointer"
              }}
              onClick={() => {
                appContext.navTo({
                  item: 'students',
                })
              }}
            >
              <div className="card-body">
                <h6
                  className="card-title"
                >
                  Students
                </h6>

                <h6
                  className="text-end"
                  style={{
                    fontSize: "42px"
                  }}
                >
                  {formatMoney(appContext.dashboardCounts?.students || 0)}
                </h6>								
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div
              className="card"
              style={{
                cursor: "pointer"
              }}
              onClick={() => {
                appContext.navTo({
                  item: 'general_payment_cycles',
                })
              }}
            >
              <div className="card-body">
                <h6
                  className="card-title"
                >
                  General Payment Cycles
                </h6>

                <h6
                  className="text-end"
                  style={{
                    fontSize: "42px"
                  }}
                >
                  {formatMoney(appContext.dashboardCounts?.generalPaymentCycles || 0)}
                </h6>								
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div
              className="card"
              style={{
                cursor: "pointer"
              }}
              onClick={() => {
                appContext.navTo({
                  item: 'individual_payment_cycles',
                })
              }}
            >
              <div className="card-body">
                <h6
                  className="card-title"
                >
                  Individual Payment Cycles
                </h6>

                <h6
                  className="text-end"
                  style={{
                    fontSize: "42px"
                  }}
                >
                  {formatMoney(appContext.dashboardCounts?.individualPaymentCycles || 0)}
                </h6>								
              </div>
            </div>
          </div>

          <div className="col-12">
            <hr/>
          </div>


          <div className="col-12 col-md-6">
            <div
              className="card"
              style={{
                cursor: "pointer"
              }}
              onClick={() => {
                appContext.navTo({
                  item: 'my_activities',
                  subItem: 'my_subjects',
                })
              }}
            >
              <div className="card-body">
                <h6
                  className="card-title"
                >
                  My Subjects
                </h6>

                <h6
                  className="text-end"
                >
                  <MdSubject size={42}/>
                </h6>								
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div
              className="card"
              style={{
                cursor: "pointer"
              }}
              onClick={() => {
                appContext.navTo({
                  item: 'my_activities',
                  subItem: 'my_exam_cycles',
                })
              }}
            >
              <div className="card-body">
                <h6
                  className="card-title"
                >
                  My Exam Cycles
                </h6>

                <h6
                  className="text-end"
                >
                  <MdSubject size={42}/>
                </h6>									
              </div>
            </div>
          </div>

        </div>

      </div>
    )
  } else {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }
}
